// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"mk","cardInnerHeading":"ml","toggleWrapperClass":"mm","textWrapperClass":"mn","toggleTextClass":"mo"};